const configs = {
    ENDPOINT: process.env.REACT_APP_ENDPOINT || "https://dabinx-backends.ue.r.appspot.com/"
}

export default configs;